<template>
    <el-input :value="value" @input="onInput"></el-input>
</template>

<script>
  export default {
    props: {
      value: null,
      name: String,
    },

    methods: {
      /**
       * @param {*} value
       */
      onInput(value) {
        this.$emit('input', {name: this.name, value});
      }
    },
  }
</script>

